/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceSnapshot } from '../models/ResourceSnapshot';
import { SecurityScan } from '../models/SecurityScan';
import { SnapshotStatus } from '../models/SnapshotStatus';

/**
* Eon snapshot.
*/
export class Snapshot {
  /**
  * Eon snapshot ID.
  */
  'id': string;
  /**
  * ID of the snapshot\'s parent project.
  */
  'projectId'?: string;
  /**
  * Date and time the snapshot creation was started. This doesn\'t represent the point in time the resource is backed up from, which is instead represented by the `pointInTime` property. 
  */
  'createdTime': Date;
  /**
  * Date and time of the resource that\'s preserved by the snapshot.
  */
  'pointInTime'?: Date;
  /**
  * ID of the vault the snapshot is stored in.
  */
  'vaultId': string;
  /**
  * Eon-assigned ID of the resource the snapshot is backing up.
  */
  'resourceId': string;
  /**
  * Date and time the snapshot\'s retention is expected to expire, after which it\'s marked for deletion.
  */
  'expirationTime'?: Date;
  /**
  * The backup retention in days
  */
  'backupRetention'?: number;
  'status': SnapshotStatus;
  'resource'?: ResourceSnapshot;
  /**
  * Size of the full snapshot in bytes.
  */
  'fullSizeBytes'?: number;
  /**
  * Size of the incremental snapshot in bytes
  */
  'incrementalSizeBytes'?: number;
  /**
  * Number of items omitted from the snapshot due to access restrictions
  */
  'accessDeniedItemsCount'?: number;
  /**
  * Total size (in bytes) of the items omitted from the snapshot due to access restrictions.
  */
  'accessDeniedItemsBytes'?: number;
  /**
  * Number of unsupported items skipped from the snapshot
  */
  'skippedItemsCount'?: number;
  'securityScan'?: SecurityScan | null;
  /**
  * Whether the snapshot is a CDC snapshot.
  */
  'isCdc'?: boolean;
  /**
  * Whether the snapshot supports PiTR.
  */
  'supportPiTR'?: boolean;
  /**
  * Whether the snapshot is with attributes backup.
  */
  'withAttributesBackup'?: boolean;
  /**
  * Whether the snapshot is protected from deletion.
  */
  'protectedFromDeletion'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "projectId",
      "baseName": "projectId",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdTime",
      "baseName": "createdTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "pointInTime",
      "baseName": "pointInTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "expirationTime",
      "baseName": "expirationTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "backupRetention",
      "baseName": "backupRetention",
      "type": "number",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "SnapshotStatus",
      "format": ""
    },
    {
      "name": "resource",
      "baseName": "resource",
      "type": "ResourceSnapshot",
      "format": ""
    },
    {
      "name": "fullSizeBytes",
      "baseName": "fullSizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "incrementalSizeBytes",
      "baseName": "incrementalSizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "accessDeniedItemsCount",
      "baseName": "accessDeniedItemsCount",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "accessDeniedItemsBytes",
      "baseName": "accessDeniedItemsBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "skippedItemsCount",
      "baseName": "skippedItemsCount",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "securityScan",
      "baseName": "securityScan",
      "type": "SecurityScan",
      "format": ""
    },
    {
      "name": "isCdc",
      "baseName": "isCdc",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "supportPiTR",
      "baseName": "supportPiTR",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "withAttributesBackup",
      "baseName": "withAttributesBackup",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "protectedFromDeletion",
      "baseName": "protectedFromDeletion",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Snapshot.attributeTypeMap;
  }

  public constructor() {
  }
}



